export enum MessageEnum {
  AnnotationsCreate = 'annotations.create',
  AnnotationsDestroy = 'annotations.destroy',
  AnnotationsInfo = 'annotations.info',
  AnnotationsSetDescription = 'annotations.setDescription',
  AnnotationsSetLabelsShown = 'annotations.setLabelsShown',
  AnnotationsSetTitle = 'annotations.setTitle',
  AnnotationsUpdate = 'annotations.update',
  AnnotationsSetEnabled = 'annotations.setEnabled',
  CameraInfo = 'camera.info',
  CameraOrbit = 'camera.orbit',
  CameraPan = 'camera.pan',
  CameraReset = 'camera.reset',
  CameraSet = 'camera.set',
  CameraZoom = 'camera.zoom',
  GetAnnotationInfo = 'annotations.info',
  HideAnnotations = 'annotations.hide',
  HideLabels = 'labels.hide',
  HotspotsCreate = 'hotspots.create',
  HotspotsDestroy = 'hotspots.destroy',
  HotspotsHide = 'hotspots.hide',
  HotspotsInfo = 'hotspots.info',
  HotspotsShow = 'hotspots.show',
  HotspotsTypes = 'hotspots.types',
  HotspotsUpdate = 'hotspots.update',
  HumanInfo = 'human.info',
  InputDisable = 'input.disable',
  InputEnable = 'input.enable',
  LabelsSetEnabled = 'labels.setEnabled',
  SceneColorObject = 'scene.colorObject',
  SceneDisableHighlight = 'scene.disableHighlight',
  SceneEnableHighlight = 'scene.enableHighlight',
  SceneGetColor = 'scene.getColor',
  SceneInfo = 'scene.info',
  SceneLoad = 'scene.load',
  ScenePick = 'scene.pick',
  SceneReset = 'scene.reset',
  SceneSelectObjects = 'scene.selectObjects',
  SceneShowObjects = 'scene.showObjects',
  SceneTransformObject = 'scene.transformObject',
  SceneUncolorObject = 'scene.uncolorObject',
  SceneSnapshot = 'scene.snapshot',
  SceneCapture = 'scene.capture',
  SceneRestore = 'scene.restore',
  SceneEnableXrayMode = 'scene.enableXray',
  SceneDisableXrayMode = 'scene.disableXray',
  ShowAnnotations = 'annotations.show',
  SetAnnotationsShown = 'annotations.setShown',
  ShowLabels = 'labels.show',
  TimelineInfo = 'timeline.info',
  TimelineQuery = 'timeline.query',
  TimelineNext = 'timeline.nextChapter',
  TimelinePause = 'timeline.pause',
  TimelinePlay = 'timeline.play',
  TimelinePrev = 'timeline.previousChapter',
  TimelineSet = 'timeline.set',
  UIGetBackground = 'ui.getBackground',
  UIGetDisplay = 'ui.getDisplay',
  UIGetWordPosition = 'ui.getWorldPosition',
  UISetBackground = 'ui.setBackground',
  UISetDisplay = 'ui.setDisplay',
  UIResetDisplay = 'ui.resetDisplay',
  UISnapshot = 'ui.snapshot',
  focusObject = 'focus.focusObject',
  dissectSetEnabled = 'dissect.setEnabled',
  pickSingleSetEnabled = 'pick.single.setEnabled',
  pickMultiSetEnabled = 'pick.multi.setEnabled',
  getCanvasPos = 'scene.getCanvasPos',
  sceneSetClickMode = 'scene.setClickMode',
  IsolateObject = 'scene.isolateObject',
  setCameraMode = 'camera.setCameraMode',
  // #TODO[AC]: implement private API calls
  // SetInitialEnabled = 'widget.enableInitial',
  // SetInitialDisabled = 'widget.disableInitial',
  // SetScrollEnabled = 'widget.enableScroll',
  // SetScrollDisabled = 'widget.disableScroll',
  UISetLoadingExperience = 'ui.setLoadingExperience',
  UISetScrollCaptureMode = 'ui.setScrollCaptureMode'
}
